import { Injectable } from "@angular/core";
import { ActivatedRoute, ResolveEnd, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: 'root'
})

export class FooterService {
	private toggleTranslation$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	public toggleTranslation$ = this.toggleTranslation$$.asObservable();
	currentRoute: string = '';

	public toggleTranslation() {
		this.toggleTranslation$$.next(!this.toggleTranslation$$.value);
	}
}